<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-02-19                                                         -
  ----------------------------------------------------------------------------->

<template>

</template>

<script>
export default {
  name: "yega1-sorter",
  props: {
    sortBy: {
      type: String,
      default: 'name'
    },
    sortFunc:{
      type:Function
    }
  },
  inject: {
    registerFilteredItemsReceiver: 'registerFilteredItemsReceiver',
    setSortedItems: 'setSortedItems',
  },
  data() {
    return {
      filtered_items: [],
      sorted_items: []
    };
  },
  created() {
    this.registerFilteredItemsReceiver(this);
  },
  methods: {
    setFilteredItems(items){
      this.filtered_items = items;
      this.sorted_items = this.sortRecords();
      this.setSortedItems(this.sorted_items);
    },
    sortRecords() {
      let sortBy = this.sortBy;
      let localSortFunction = this.sortFunc;
      if(!localSortFunction){
        localSortFunction = function(a,b){
          let aVal = a[sortBy] ? a[sortBy] : '';
          let bVal = b[sortBy] ? b[sortBy] : '';
          return ('' + aVal).localeCompare('' + bVal);
        }
      }
      return this.filtered_items.sort(localSortFunction);
    }
  }
}
</script>

<style scoped>

</style>